const state = () => ({
  entityStatus: null
})

const mutations = {
  set(state, exhibitor) {
    state = Object.assign(state, exhibitor)
  },
}

const getters = {
  get: (state) => {
    return state
  },

}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
